var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V16C20 14.9 19.1 14 18 14H6C4.9 14 4 14.9 4 16ZM17 18H7C6.45 18 6 17.55 6 17C6 16.45 6.45 16 7 16H17C17.55 16 18 16.45 18 17C18 17.55 17.55 18 17 18ZM12 2C9.54 2 7.48 3.79 7.07 6.13C6.99 6.65 7.13 7.18 7.43 7.6L11.19 12.86C11.59 13.42 12.42 13.42 12.82 12.86L16.58 7.6C16.88 7.18 17.02 6.65 16.93 6.13C16.52 3.79 14.46 2 12 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalIcon);
export default __webpack_public_path__ + "static/media/ApprovalIcon.d8f5b21c276376a7a0315e0fa6e9f4b1.svg";
export { ForwardRef as ReactComponent };